(function () {
  var STORAGE_KEY = 'torii_wishlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
    updateCountBadge();
  }

  function updateCountBadge() {
    var count = read().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    document.querySelectorAll('[data-wishlist-count-link]').forEach(function (link) {
      if (count === 0) {
        link.setAttribute('aria-label', 'Favoritos');
      } else if (count === 1) {
        link.setAttribute('aria-label', 'Favoritos, 1 producto');
      } else {
        link.setAttribute('aria-label', 'Favoritos, ' + count + ' productos');
      }
    });
  }

  function toggle(item) {
    var items = read();
    var index = items.findIndex(function (entry) {
      return entry.handle === item.handle;
    });

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push(item);
    }

    write(items);
    return items;
  }

  function isSaved(handle) {
    return read().some(function (entry) {
      return entry.handle === handle;
    });
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Agregar a favoritos');

    var img = button.querySelector('img');
    if (!img) return;

    var activeIcon = button.dataset.wishlistIconActive;
    var outlineIcon = button.dataset.wishlistIconOutline;

    if (activeIcon && outlineIcon) {
      img.src = active ? activeIcon : outlineIcon;
    }
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.dataset.wishlistHandle;
      if (!handle) return;

      setButtonState(button, isSaved(handle));

      if (button.dataset.wishlistBound === 'true') return;
      button.dataset.wishlistBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        toggle({
          handle: handle,
          title: button.dataset.wishlistTitle || '',
          url: button.dataset.wishlistUrl || '#',
          image: button.dataset.wishlistImage || '',
          price: button.dataset.wishlistPrice || ''
        });

        setButtonState(button, isSaved(handle));
      });
    });
  }

  function renderGrid(container) {
    if (!container) return;

    var items = read();
    var empty = container.querySelector('[data-wishlist-empty]');

    container.querySelectorAll('.wishlist-card').forEach(function (node) {
      node.remove();
    });

    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    items.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'home-product-card wishlist-card';
      card.innerHTML =
        '<div class="home-product-card__media">' +
          '<a class="home-product-card__media-link" href="' + item.url + '">' +
            (item.image ? '<img class="home-product-card__image" src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '') +
          '</a>' +
        '</div>' +
        '<div class="home-product-card__info">' +
          '<h3 class="home-product-card__name"><a href="' + item.url + '" style="color:inherit;text-decoration:none;">' + item.title + '</a></h3>' +
          (item.price ? '<p class="home-product-card__price">' + item.price + '</p>' : '') +
          '<a class="home-btn" href="' + item.url + '">Ver producto</a>' +
        '</div>';
      container.appendChild(card);
    });
  }

  window.ToriiWishlist = {
    read: read,
    toggle: toggle,
    isSaved: isSaved,
    bindButtons: bindButtons,
    renderGrid: renderGrid,
    updateCountBadge: updateCountBadge
  };

  document.addEventListener('DOMContentLoaded', function () {
    bindButtons();
    updateCountBadge();
  });

  document.addEventListener('wishlist:updated', function () {
    updateCountBadge();
  });

  document.addEventListener('shopify:section:load', function (event) {
    bindButtons(event.target);
  });
})();
